import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons"
import { computed, ref, type InputHTMLAttributes } from "vue"
import { defineComponent, inferProps, refSetter, type ReactiveComponent } from "vue-utils"
import Icon from "../Icon"
import AutoCompleteTextInput from "./AutoCompleteTextInput"
import BootstrapButton from "./BootstrapButton"

interface Props {
	options: string[]
	select(text: string): void

	placeholder: string
	noOptionsText: string
	mustMatch: boolean

	iconOnly?: boolean
	inputAttributes?: InputHTMLAttributes

	cancel(): void
}

const AddEntityForm: ReactiveComponent<Props> = (props) => {
	const currentSearch = ref("")
	const usedSearch = computed(() => currentSearch.value.trim())
	const possibleOptions = computed(() => new Set<string>(props.options))

	const allowSubmit = computed(() => {
		const option = usedSearch.value
		if (option.length === 0) {
			return false
		}
		if (props.mustMatch && !possibleOptions.value.has(option)) {
			return false
		}
		return true
	})

	function handleSubmit(e: Event) {
		e.preventDefault()
		if (allowSubmit.value) {
			props.select(usedSearch.value.trim())
		}
	}

	return () => (
		<form class="flex w-full spacing-2 spacing-2 mt-2" onSubmit={handleSubmit} style={{ alignItems: "stretch" }}>
			<AutoCompleteTextInput
				options={props.options}
				noOptionsText={props.noOptionsText}
				value={currentSearch.value}
				setValue={refSetter(currentSearch)}
				onOptionSelected={(option) => {
					currentSearch.value = option
					props.select(option)
				}}
				placeholder={props.placeholder}
				onKeyup={(e) => e.key === "Enter" && handleSubmit(e)}
				containerAttrs={{ class: "flex-grow-1" }}
				openOnFocus
				openOnMount
				required
				{...props.inputAttributes}
			/>
			<BootstrapButton type="button" color="secondary" onClick={props.cancel}>
				<Icon icon={faTimes} />
				{!props.iconOnly && "Cancel"}
			</BootstrapButton>
			<BootstrapButton type="submit" color="primary" disabled={!allowSubmit.value}>
				<Icon icon={faCheck} />
				{!props.iconOnly && "Add"}
			</BootstrapButton>
		</form>
	)
}

export default defineComponent(AddEntityForm, inferProps<Props>())
